import { GetRequest, PostRequest } from '../lib/request';

const GET_MY_LICENSES_PATH = `/my-account/my-licenses/api/get-my-developer-licenses`;
const GET_MY_PERIPHERAL_LICENSES_PATH = `/my-account/my-licenses/api/get-my-peripheral-licenses`;
const POST_REGISTER_LICENSE = `/my-account/my-licenses/api/register-license`;

export async function GetMyDeveloperLicenses(refresh) {

    try {
        if (refresh) {
            return await GetRequest(`${GET_MY_LICENSES_PATH}/true`);
        } else {
            return await GetRequest(`${GET_MY_LICENSES_PATH}/false`);
        }
    } catch (ex) {
        throw new Error("Unable to fetch licenses from remote server.")
    }

}

export async function GetMyPeripheralLicenses(refresh) {
    try {
        if (refresh) {
            return await GetRequest(`${GET_MY_PERIPHERAL_LICENSES_PATH}/true`);
        } else {
            return await GetRequest(`${GET_MY_PERIPHERAL_LICENSES_PATH}/false`);
        }
    } catch (ex) {
        throw new Error("Unable to fetch licenses from remote server.")
    }
}

export async function RegisterLicense(data){

    try{
        return await PostRequest(POST_REGISTER_LICENSE, data);
    }catch(ex){
        throw new Error("Unable to register with the remote server.");
    }
    
}